import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'

const AppForm = ({
  values,
  handleChange,
  errors,
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='file_url'
          name='file_url'
          colSize='12'
          inputLabel='Link url'
          className='mb-3'
          placeholder='Enter link url...'
          value={values.file_url}
          handleTextInput={handleChange}
          feedbackInvalid={'Please enter link url'}
          invalid={errors.file_url}
        />
        <FormTextInput 
          id='file_name'
          name='file_name'
          colSize='6'
          inputLabel='Link Name'
          className='mb-3'
          placeholder='Enter link name...'
          value={values.file_name}
          handleTextInput={handleChange}
          feedbackInvalid={'Please enter link name'}
          invalid={errors.file_name}
        />
        <FormTextAreaInput
          id='file_description'
          name='file_description'
          colSize='6'
          inputLabel='Link Description'
          className='mb-3'
          placeholder='Enter link description...'
          rows='5'
          value={values.file_description}
          handleTextAreaInput={handleChange}
          feedbackInvalid={'Please enter link description'}
          invalid={errors.file_description}
        />
      </CRow>
    </>
  )
}

export default AppForm